import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';
import { useStyle } from './style';

var ProCardOperation = function ProCardOperation(props) {
  var className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      children = props.children;

  var _useContext = useContext(ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-card-operation');

  var _useStyle = useStyle(prefixCls),
      wrapSSR = _useStyle.wrapSSR;

  var classString = classNames(prefixCls, className);
  return wrapSSR(_jsx("div", {
    className: classString,
    style: style,
    children: children
  }));
};

export default ProCardOperation;